"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RaiseIssueActionPicker = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const WorkflowAction_1 = __importDefault(require("@opsbase/lib-workflow/WorkflowAction"));
const useStaffFindById_1 = __importDefault(require("@opsbase/react-gql-hooks/staff/useStaffFindById"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const StaffChooser_1 = __importDefault(require("@opsbase/web-data-choosers/StaffChooser"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const FlagPicker_1 = __importDefault(require("@opsbase/web-pickers/FlagPicker"));
const IssueTypePicker_1 = __importDefault(require("@opsbase/web-pickers/IssueTypePicker"));
const TextFieldWithStateAndBlur_1 = __importDefault(require("@opsbase/web-textfield/TextFieldWithStateAndBlur"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
const yup = __importStar(require("yup"));
const makeMyClasses = () => ({
    errorText: {
        padding: 4,
        backgroundColor: lib_palette_1.default.BadRed.light,
    },
});
function RaiseIssueActionPicker(props) {
    var _a;
    const { action, onChangeAction, disabled = false } = props;
    const config = action === null || action === void 0 ? void 0 : action.workflowActionConfig;
    const { data: staff } = (0, useStaffFindById_1.default)({ variables: { id: (_a = config === null || config === void 0 ? void 0 : config.reporter) === null || _a === void 0 ? void 0 : _a.id } });
    const createChangeHandler = (0, react_1.useCallback)(field => value => {
        config[field] = value;
        action.workflowActionConfig = config;
        onChangeAction(new WorkflowAction_1.default(action));
    }, [config, action, onChangeAction]);
    const myCss = (0, web_css_1.default)(makeMyClasses, []);
    const handleChangeTitle = (0, react_1.useMemo)(() => createChangeHandler('title'), [createChangeHandler]);
    const handleChangeType = (0, react_1.useMemo)(() => createChangeHandler('type'), [createChangeHandler]);
    const handleChangeFlag = (0, react_1.useMemo)(() => createChangeHandler('flag'), [createChangeHandler]);
    const handleChangeReporter = (0, react_1.useCallback)(reporter => {
        var _a, _b;
        config.reporter = {
            id: (_a = reporter === null || reporter === void 0 ? void 0 : reporter[0]) === null || _a === void 0 ? void 0 : _a.id,
            title: (_b = reporter === null || reporter === void 0 ? void 0 : reporter[0]) === null || _b === void 0 ? void 0 : _b.title,
        };
        action.workflowActionConfig = config;
        onChangeAction(new WorkflowAction_1.default(action));
    }, [config, action, onChangeAction]);
    const validationStr = (0, react_1.useMemo)(() => {
        try {
            const validationSchema = yup.object().shape({
                title: yup
                    .string()
                    .trim()
                    .required(`${lib_i18n_1.default.t('title')}: ${lib_i18n_1.default.t('error-invalid-required')}`),
                type: yup
                    .string()
                    .trim()
                    .required(`${lib_i18n_1.default.t('issue-type')}: ${lib_i18n_1.default.t('error-invalid-required')}`),
                flag: yup
                    .string()
                    .trim()
                    .required(`${lib_i18n_1.default.t('flag')}: ${lib_i18n_1.default.t('error-invalid-required')}`),
            });
            validationSchema.validateSync({
                title: config.title,
                flag: config.flag,
                type: config.type,
            });
        }
        catch (e) {
            return e.errors.join('\n');
        }
    }, [config.flag, config.title, config.type]);
    return (react_1.default.createElement(Vertical_1.default, { gutter: true },
        validationStr ? react_1.default.createElement(Text_1.default, { className: myCss.errorText }, `${validationStr}`) : null,
        react_1.default.createElement(Horizontal_1.default, { centered: true, gutter: true, justify: 'flex-start' },
            react_1.default.createElement(Text_1.default, { style: { minWidth: 100 } }, lib_i18n_1.default.t('title')),
            react_1.default.createElement(TextFieldWithStateAndBlur_1.default, { disabled: disabled, fullWidth: true, value: config.title, onBlur: handleChangeTitle })),
        react_1.default.createElement(Horizontal_1.default, { centered: true, gutter: true, justify: 'flex-start' },
            react_1.default.createElement(Text_1.default, { style: { minWidth: 100 } }, lib_i18n_1.default.t('issue-type')),
            react_1.default.createElement(Pane_1.default, { grow: true },
                react_1.default.createElement(IssueTypePicker_1.default, { disabled: disabled, fullWidth: true, noMargin: true, white: true, value: config.type, onChange: handleChangeType }))),
        react_1.default.createElement(Horizontal_1.default, { centered: true, gutter: true, justify: 'flex-start' },
            react_1.default.createElement(Text_1.default, { style: { minWidth: 100 } }, lib_i18n_1.default.t('flag')),
            react_1.default.createElement(Pane_1.default, { grow: true },
                react_1.default.createElement(FlagPicker_1.default, { disabled: disabled, fullWidth: true, value: config.flag, onChange: handleChangeFlag }))),
        react_1.default.createElement(Horizontal_1.default, { centered: true, gutter: true, justify: 'flex-start' },
            react_1.default.createElement(Text_1.default, { variant: "h3" }, lib_i18n_1.default.t('select-reporter')),
            react_1.default.createElement(StaffChooser_1.default, { disabled: disabled, value: staff ? [staff] : undefined, onChange: handleChangeReporter }))));
}
exports.RaiseIssueActionPicker = RaiseIssueActionPicker;
exports.default = RaiseIssueActionPicker;
